<template>
    <div class="container">
        <div class="header">
            <van-swipe 
                :autoplay="3000"
                class="swipe-box"
                :showIndicators="false"
            >
                <van-swipe-item v-for="(image, index) in productInfo.imageList" :key="index">
                    <van-image 
                        v-touch:tap="lookImage(index)"
                        class="header-image"
                        lazy-load
                        fit="cover"
                        :src="image"
                    />
                </van-swipe-item>
            </van-swipe>
            <!-- <i class="iconfont icongouwuche shopping-car f-c"></i> -->
        </div>

        <ul class="body">
            <li class="body-render-item body-top-box">
                <div class="product-name g-b-500">{{productInfo.name}}</div>
                <div class="product-price f-c g-b-500">
                    <span class="rmb">¥</span>
                    <span class="price">{{productInfo.price}}</span>
                </div>
                <div class="f-s-b sku-box" v-touch:tap.prevent="showSku('')">
                    <span>规格</span>
                    <i class="iconfont iconjiantouarrow487 icon-size"></i>
                </div>
            </li>
            <li class="body-render-item f-s-b ">
                <div
                    class="f-s-b"
                    v-for="(item, index) in labelList" :key="index"
                >
                    <van-image 
                        class="label-image"
                        lazy-load
                        fit="cover"
                        :src="item.image"
                    />
                    <div class="label-name">{{item.name}}</div>
                </div>
            </li>
            <li class="body-render-item comment-box ">
                
                <div class="comment-title-box  f-s-b" v-touch:tap.prevent="onChangeCommentShow">
                    <div class="f-s-b" >
                        <van-image 
                            class="label-image"
                            lazy-load
                            :src="labelImage"
                        />
                        <div class="label-name comment-name f-c">
                            <span>评价</span>
                            <span class="label-name comment-count">({{AllCommentList.length}}条)</span>
                        </div>
                    </div>
                    <div style="color: #595959;">
                        <i class="iconfont iconjiantouarrow487 icon-size"></i>
                    </div>
                </div>

                <div 
                    v-for="(item, index) in commentList" :key="index"
                    class="comment-render-box"
                >
                    <div class="render-top f-s-b">
                        <van-image 
                            class="user-image"
                            lazy-load
                            :src="item.userImage"
                        />
                        <div class="user-info f-s-b">
                            <span class="name g-b-500">{{item.userNmae}}</span>
                            <span>{{item.time}}</span>
                        </div>
                    </div>
                    <div class="render-below">
                        {{item.content}}
                    </div>
                </div>

            </li>
            <li class="body-render-item tips-box f-s-b">
                
                    <van-image 
                        class="tips-image"
                        lazy-load
                        fit="cover"
                        :src="lineImage"
                    />
                    <div class="title">宝贝详情</div>
                    <van-image 
                        class="tips-image right-image"
                        lazy-load
                        fit="cover"
                        :src="lineImage"
                    />

            </li>
            <li class="body-render-item">
                <div v-html="tempDom"></div>
            </li>
        </ul>

        <div class="foot f-s-b">
            <div class="foot-left f-c" v-touch:tap.prevent="routerPage('haibotang')">
                <i class="iconfont iconwenwuziyuan icon-size"></i>
                <div class="">海博堂</div>
            </div>
            <div class="foot-left f-c" v-touch:tap.prevent="routerPage('shopCar')">
                <i class="iconfont icongouwuche icon-size"></i>
                <div class="">购物车</div>
                <span class="product-number f-c" v-if="shoppingCarSize>0">{{shoppingCarSize}}</span>
            </div>
            <div class="foot-right f-s-b g-b-500">
                <div class="f-c add-shopping-car" v-touch:tap.prevent="showSku('addToshopCar')">加入购物车</div>
                <div class="f-c first-buy" v-touch:tap.prevent="showSku('productDetail')">立即购买</div>
            </div>
        </div>

        <van-popup 
            v-model="show"
            round
            class="sku-box"
            position="bottom"
        >
            <ul class="sku-container">
                <li class="sku-header f-s-b">
                    <van-image 
                        class="sku-header-image"
                        lazy-load
                        fit="cover"
                        :src="productInfo.imageList[0]"
                    />
                    <div class="sku-header-info g-b-500 f-s-b">
                        <div class="info-left">
                            <span class="now-price">
                                <i>¥</i>
                                <i>{{getCurrentSkuInfo.rawData.REAL_PRICE}}</i>
                            </span>
                            <span class="old-price">
                                <i>¥</i>
                                <i>{{productInfo.price}}</i>
                            </span>
                        </div>
                        <div class="info-right">
                            <span class="txt">剩余:</span>
                            <span class="count">{{getCurrentSkuInfo.rawData.NUMBER > 0 ? getCurrentSkuInfo.rawData.NUMBER : 0}}</span>
                        </div>
                    </div>
                </li>
                <li class="sku-body">
                    <div class="body-title ellipsis">规格分类</div>
                    <ul class="body-contaier">
                        <li 
                            v-for="(item, index) in skuList" :key="index"
                            class="render-item-box f-c ellipsis"
                            :class="item.index === skuActive ? 'render-item-box-active':''"
                            v-touch:tap="onChangeSku(item)"
                        >
                            {{item.name}}
                        </li>
                    </ul>
                </li>
                <li class="sku-foot">
                    <div class="foot-header">数量</div>
                    <van-stepper 
                        :show-plus="showBtn"
                        v-model="value" 
                        :min="getCurrentSkuInfo.rawData.NUMBER > 0 ? 1 : 0" 
                        integer
                        :max="getCurrentSkuInfo.rawData.NUMBER > 0 ? getCurrentSkuInfo.rawData.NUMBER : 0"
                    />
                </li>
                <li class="sku-btn-box">
                    <div class="sku-btn f-c g-b-500" v-touch:tap="skuCommit">确定</div>
                </li>
            </ul>

        </van-popup>

        <van-popup
            v-model="commentShow"
            round
            position="bottom"
            closeable
            :style="{ minHeight: '30%', maxHeight: '80%' }"
            class="comment-popup-box "
        >
            <div 
                v-if="AllCommentList.length"
                class="comment-box"
            >
                <div 
                    v-for="(item, index) in AllCommentList" :key="index"
                    class="comment-render-box"
                >
                    <div class="render-top f-s-b">
                        <van-image 
                            class="user-image"
                            lazy-load
                            :src="item.userImage"
                        />
                        <div class="user-info f-s-b">
                            <span class="name g-b-500">{{item.userNmae}}</span>
                            <span>{{item.time}}</span>
                        </div>
                    </div>
                    <div class="render-below">
                        {{item.content}}
                    </div>
                </div>
            </div>

            <div v-else class="comment-render-box f-c" style="height:200px;">暂无评论</div>

        </van-popup>

    </div>
</template>

<script>
    import { 
        Swipe, 
        SwipeItem, 
        Sku,
        Popup,
        Stepper,
        ImagePreview,
    } from 'vant';
    import {
        productDetailUrl,
        productCommentListUrl,
        saveShoppingCartUrl,
        getShoppingCartUrl,
    } from '@js/shoppingUrl.js';

    import http from '@js/http-hbt.js';

    export default {
        data() {
            return {
                showBtn:true,
                labelImage: require('@image/shopping/534.png'),
                lineImage: require('@image/shopping/3.png'),
                show: false,
                commentShow: false,
                value:0,
                skuActive: 0,
                skuType: "",
                skuList:[
                    {
                        name: '白色白色白色白色白色',
                        index: 0,
                    },
                    {
                        name: '红色',
                        index: 1,
                    },
                    {
                        name: '黑色',
                        index: 2,
                    },
                    {
                        name: '黑2色',
                        index: 3,
                    },
                    {
                        name: '2黑色',
                        index: 4,
                    },
                    {
                        name: '黑色2',
                        index: 5,
                    },
                    {
                        name: '2黑2色2',
                        index: 6,
                    },
                ],
                productInfo: {
                    imageList: [
                        require('@image/shopping/34.png'),
                        require('@image/shopping/45.png'),
                        require('@image/shopping/89.png'),
                        require('@image/shopping/688.png'),
                        require('@image/shopping/4555.png'),
                    ],
                    name: '2020年 满汉全席日历 日历菜谱与传统文化相结合碗碟',
                    // oldPrice: '120',
                    price: '45',
                },
                commentList: [
                    {
                        userNmae: '李美玲',
                        time: '2019-11-20  09:30',
                        userImage: require('@image/shopping/oval5.png'),
                        content: '以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、非常好的东西，喜欢值得购买！',
                    },
                    {
                        userNmae: '王丽丽',
                        time: '2019-11-20  09:30',
                        userImage: require('@image/shopping/oval9.png'),
                        content: '以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、非常好的东西，喜欢值得购买！',
                    },
                    {
                        userNmae: '李美丽',
                        time: '2019-11-20  09:30',
                        userImage: require('@image/shopping/oval58.png'),
                        content: '以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、非常好的东西，喜欢值得购买！',
                    },
                ],
                AllCommentList: [],
                labelList: [
                    {
                        name: '博物馆精品',
                        image: require('@image/shopping/2.png'),
                    },
                    {
                        name: '急速发货',
                        image: require('@image/shopping/342.png'),
                    },
                    {
                        name: '7天无理由退货',
                        image: require('@image/shopping/3534.png'),
                    },
                ],
                tempDom: '暂无详情介绍',
                productId: '',
                shoppingCar: [],
                shoppingCarSize: 0,
            }
        },
        created() {
            this.commentList = [];
            //  清空临时本地购物车
            this.$store.commit('setShopCar');
            var {
                id
            } = this.$route.query;
            this.productId = id;
            this.getProductInfo(id);
            this.getProductCommentList(id);
            this.getShoppingCart();
        },
        methods: {
            getProductInfo(id){
                this.productInfo.imageList = [];
                this.skuList = [];
                this.productInfo.name = '暂无商品名称';
                this.productInfo.price = 0;
                http.post(productDetailUrl,{id})
                .then(res=>{
                    var{
                        data
                    } = res;
                    //  轮播图片
                    data.productPics.map(item=>{
                        this.productInfo.imageList.push(this.getImagePrefix + item.URL)
                    })
                    //  商品基本信息
                    this.productInfo.name = data.baseInfo.PRODUCT_NAME;
                    this.productInfo.price = data.baseInfo.SELL_PRICE;
                    //  商品详情
                    this.tempDom = data.baseInfo.DESC_M;
                    //  商品规格
                    data.skus.map((item,index)=>{
                        this.skuList.push({
                            name: item.SKU_NAME,
                            index,
                            rawData: item,
                        });
                    })
                    // console.log(res)
                })
            },
            getProductCommentList(id){
                http.post(productCommentListUrl,{id})
                    .then(res=>{
                        // console.log('评论',res)
                        var {
                            data: array = []
                        } = res;
                        array.map(item=>{
                            this.AllCommentList.push({
                                userNmae: item.NICKNAME || '游客',
                                time: item.CREATE_TIME,
                                userImage: this.getImagePrefix + item.USER_IMG,
                                content: item.CONTENT,
                                rawData: item,
                            })
                        })
                        array.slice(0,3).map(item=>{
                            this.commentList.push({
                                userNmae: item.NICKNAME || '游客',
                                time: item.CREATE_TIME,
                                userImage: this.getImagePrefix + item.USER_IMG,
                                content: item.CONTENT,
                                rawData: item,
                            })
                        })
                    })
            },
            onChangeCommentShow() {
                this.commentShow = !this.commentShow;
            },
            lookImage(index){
                return ()=>{
                    ImagePreview({
                        images: this.productInfo.imageList,
                        startPosition: index,
                        closeable: true
                    });
                }
            },
            chooseSku() {
                this.show = !this.show;
                if(this.show){
                    //  处理vant的input输入
                    var tempCount = setTimeout(() => {
                        clearTimeout(tempCount);
                        var inputS = document.getElementsByTagName('input');
                        for (let index = 0, len = inputS.length; index < len; index++) {
                            const element = inputS[index];
                            element.readOnly = true;
                        }
                    }, 300);
                }
            },
            showSku(type = ""){
                return ()=>{
                    this.skuType = type;
                    this.chooseSku();
                }
            },
            saveShoppingCart(data){
                http.post(saveShoppingCartUrl, data).then(res=>{
                    this.$toast.success('加入至购物车成功');
                    this.shoppingCar = [];
                    this.shoppingCarSize = 0;
                    this.getShoppingCart();
                })
            },
            getShoppingCart(){
                http.post(getShoppingCartUrl,{ userId: this.getUserId, searchWord: '' })
                    .then(res=>{
                        // console.log('购物车数据', res)
                        var{
                            data: array = []
                        } = res;
                        if(array.length>0){
                            array.map(item=>{
                                this.shoppingCar.push({
                                    skuId: item.skuId,
                                    productId: item.productId,
                                    cartNum: item.cartNum,
                                })
                            })
                            this.shoppingCarSize = array.length;
                        }
                    })
            },
            skuCommit(){
                switch (this.skuType) {
                    case "addToshopCar":
                        var tempData = {
                            skuId: this.getCurrentSkuInfo.rawData.ID,
                            productId: this.productId,
                            cartNum: this.value,
                            // cartPrice: this.getCurrentSkuInfo.rawData.REAL_PRICE,
                        },
                        flag = true;

                        this.shoppingCar.map(item=>{
                            if(item.skuId === tempData.skuId){
                                item.cartNum = Number(item.cartNum) + Number(tempData.cartNum);
                                flag = false;
                            }
                        })
                        if(flag){
                            this.shoppingCar.push(tempData);
                        }
                        var data = {
                            userId: this.getUserId,
                            content: JSON.stringify(this.shoppingCar),
                        }
                        this.saveShoppingCart(data)
                        break;
                    case "productDetail":
                        var data = {
                            productId: this.productId,
                            skuId: this.getCurrentSkuInfo.rawData.ID,
                            number: this.value,
                            rawData: this.getCurrentSkuInfo.rawData,
                            productInfo: this.productInfo
                        }
                        this.$store.commit('addToShopCar',data);
                        this.goToCreatedOrder();
                        // this.routerPage('orderPage');
                        break;
                    default:
                        break;
                }
                this.chooseSku();
            },
            goToCreatedOrder() {
                this.$router.push({ name: 'orderPage' })
            },
            routerPage(name){
                return ()=> this.$router.push({ name })
            },
            onChangeSku(sukItem){
                return ()=>{
                    this.skuActive = sukItem.index;
                }
            }
        },
        // watch: {
        //     value(v){
        //         if(this.value > this.getCurrentSkuInfo.NUMBER){
        //             this.value = this.getCurrentSkuInfo.NUMBER;
        //         }
        //     }
        // },
        computed: {
            getUserId(){
                return this.$store.state.userInfo.userId || '';
            },
            getImagePrefix(){
                return this.$store.state.shoppingBlock.bgImgPrefix || "";
            },
            getCurrentSkuInfo(){
                return this.skuList[this.skuActive] || {rawData:{}}
            },
        },
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Sku.name]: Sku,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
            [ImagePreview.name]: ImagePreview,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 60px)" !important;
        position: relative;
        .header{
            .header-image{
                height: 276px;
                width: 100%;
            }
            img{
                height: 100%;
                width: 100%;
            }
            .shopping-car{
                color: #ffffff;
                width:30px;
                height:30px;
                background:rgba(0,0,0,1);
                opacity:0.43;
                position: absolute;
                right: 16px;
                top: 16px;
                border-radius: 100%;
                overflow: hidden;
                z-index: 55;
            }
        }
        .body{
            // transform: translateY(-20px);

            position: absolute;
            top: 258px;
            left: 0;
            right: 0;
            height: auto;
            box-sizing: border-box;

            padding: 0 7px 7px;
            .body-render-item{
                overflow: hidden;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                overflow: hidden;
                font-size: 12px;
                color: #7D838F;
                padding: 16px;
                margin-bottom: 12px;
                &:last-of-type{
                    margin-bottom: 5px;
                }
                .label-image{
                    width:24px;
                    height:24px;
                    border-radius: 100%;
                    overflow: hidden;
                }
                .label-name{
                    font-size: 13px;
                    color: #2B2B2B;
                    margin-left: 7px;
                }
            }
            .body-top-box{
                .product-name{
                    font-size: 14px;
                    color: #35373C;
                }
                .product-price{
                    justify-content: flex-start;
                    font-size: 12px;
                    border-bottom: .5px solid #EAEAEA;
                    padding-top: 5px;
                    padding-bottom: 12px;
                    margin-bottom: 12px;
                    color: #FF7613;
                    .price{
                        margin-left: 3px;
                        font-size: 18px;
                    }
                    .rmb{
                        transform: translateY(1.5px);
                    }
                }
                .sku-box{
                    color: #595959;
                }
            }
            .comment-box{
                margin: 0;
                flex-direction: column;
                .comment-title-box{
                    border-bottom: .5px solid #EAEAEA;
                    padding-bottom: 12px;
                    margin-bottom: 12px;
                    width: 100%;
                    .comment-name{
                        height: 24px;
                    }
                    .comment-count{
                        color: #f8a320;
                    }
                }
                .comment-render-box{
                    margin-bottom: 10px;
                    &:last-of-type{
                        margin: 0;
                    }
                    .render-top{
                        .user-image{
                            width:50px;
                            height:50px;
                            overflow: hidden;
                            border-radius: 100%;
                            box-sizing: border-box;
                        }
                        .user-info{
                            height:50px;
                            box-sizing: border-box;
                            align-items: baseline;
                            padding-left: 10px;
                            width: ~"calc(100% - 50px)";
                            font-size: 14px;
                            color: #7D838F;
                            .name{
                                color: #79A3FC;
                            }
                        }
                    }
                    .render-below{
                        margin-top: 10px;
                    }
                }
            }
            .tips-box{
                background-color: transparent;
                box-shadow: none;
                margin: 0;
                color: #2D537A;
                font-size: 13px;
                .title{
                    margin: 0 12px;
                }
                .tips-image{
                    flex: 1;
                }
                .right-image{
                    transform: rotate(180deg);
                }
            }
        }
        .foot{
            height: 40px;
            overflow: hidden;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            background:rgba(255,255,255,1);
            border-top-left-radius:5px;
            border-top-right-radius:5px;
            padding: 10px 12px;
            .foot-left{
                position: relative;
                color: #686868;
                .icon-size{
                    color: #9C9C9C;
                    &::before{
                        font-size: 22px;
                    }
                }
                font-size: 12px;
                flex-direction: column;
                .product-number{
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    color: #ffffff;
                    background-color: red;
                    font-size: 12px;
                    border-radius: 100%;
                    min-width: 19px;
                    min-height: 19px;
                    display: inline-flex;
                    vertical-align: middle;
                }
            }
            .foot-right{
                font-size: 13px;
                width:222px;
                height:40px;
                box-sizing: border-box;
                overflow: hidden;
                color: #ffffff;
                border-radius:19px;
                background:linear-gradient(157deg,rgba(255,163,0,1) 0%,rgba(255,63,54,1) 100%);
                .add-shopping-car{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                    background:linear-gradient(146deg,rgba(255,200,2,1) 0%,rgba(254,151,1,1) 100%);
                }
                .first-buy{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                }
            }
        }
        .sku-box{
            width: 100%;
            min-height: 60%;
            padding: 14px;
            box-sizing: border-box;
            font-size: 12px;
            .p-b{
                margin-bottom: 20px;
            }
            .sku-container{
                .sku-header{
                    .p-b();
                    .sku-header-image{
                        width:86px;
                        height:86px;
                        border-radius:6px;
                        overflow: hidden;
                    }
                    .sku-header-info{
                        width: ~"calc(100% - 86px)";
                        padding-left: 12px;
                        font-size: 16px;
                        color: #C2C2C2;
                        .now-price{
                            color: #FF7613;
                        }
                        .old-price{
                            font-size: 14px;
                            margin-left: 8px;
                            text-decoration: line-through;
                        }
                        .info-right{
                            font-size: 12px;
                            .count{
                                margin-left: 5px;
                            }
                        }
                    }
                }

                .sku-body{
                    margin-bottom: 12px;
                    .body-title{
                        margin-bottom: 12px;
                    }
                    .body-contaier{
                        .render-item-box{
                            transition: all .3s ease;
                            display: inline-block;
                            vertical-align: top;
                            box-sizing: border-box;
                            background:rgba(241,241,241,1);
                            border-radius:2px;
                            color: #666666;
                            margin-right: 10.6px;
                            margin-bottom: 8px;
                            padding: 5px 0px;
                            width: ~'calc(25% - 8px)';
                            box-sizing: border-box;
                            text-align: center;
                            border:1px solid transparent;

                            // width: ~"calc(100% - 0px)";
                            // width: 25%;
                            // width: 25%;
                            // height: 24px;
                            &:last-of-type{
                                }
                            &:nth-child(4n+4){
                                margin-right: 0;
                            }
                        }
                        .render-item-box-active{
                            color:#FD7A00;
                            border:1px solid rgba(255,134,1,1);
                            background:rgba(255,241,215,1);
                        }
                    }
                }

                .sku-foot{
                    margin-bottom: 54px;
                    .foot-header{
                        .p-b();
                    }
                }

                .sku-btn-box{
                    background-color: #ffffff;
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    padding: 0 14px 14px;
                    .sku-btn{
                        height: 40px;
                        background: linear-gradient(157deg, #ffa300 0%, #ff3f36 100%);
                        border: 0;
                        border-radius: 100px;
                        color: #ffffff;
                        font-size: 15px;
                    }
                }
            }
        }
        .comment-popup-box{
            .comment-box{
                padding: 45px 20px 20px;
                box-sizing: border-box;
                margin-bottom: 10px;
                &:last-of-type{
                    margin: 0;
                }
                .render-top{
                    .user-image{
                        width:50px;
                        height:50px;
                        overflow: hidden;
                        border-radius: 100%;
                        box-sizing: border-box;
                    }
                    .user-info{
                        height:50px;
                        box-sizing: border-box;
                        align-items: baseline;
                        padding-left: 10px;
                        width: ~"calc(100% - 50px)";
                        font-size: 14px;
                        color: #7D838F;
                        .name{
                            color: #79A3FC;
                        }
                    }
                }
                .render-below{
                    margin-top: 10px;
                }
            }
            .comment-render-box{
                    margin-bottom: 10px;
                    &:last-of-type{
                        margin: 0;
                    }
                    .render-top{
                        .user-image{
                            width:50px;
                            height:50px;
                            overflow: hidden;
                            border-radius: 100%;
                            box-sizing: border-box;
                        }
                        .user-info{
                            height:50px;
                            box-sizing: border-box;
                            align-items: baseline;
                            padding-left: 10px;
                            width: ~"calc(100% - 50px)";
                            font-size: 14px;
                            color: #7D838F;
                            .name{
                                color: #79A3FC;
                            }
                        }
                    }
                    .render-below{
                        margin-top: 10px;
                    }
                }
        }
    }
</style>